import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs')(
  {
    staticData: {
      title: 'Serverless Space',
    },
    head,
    component: lazyRouteComponent(() => import('@/components/Serverless/SpaceLayout'), 'SpaceLayoutComponent'),
  },
);
